<template>
    <v-chart  
    style="width:100%;"
    :auto-resize="true"
    ref="chart"/>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart,LineChart  } from "echarts/charts";
// import ECharts from 'echarts';
import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent
]);
export default {
    name:'chartmemberage',
    components:{
        VChart
    },
    provide: {
        [THEME_KEY]: "light"
    },
    created(){
        setTimeout(()=>{
            this.setoption();
        },1000)
        
    },
    mounted() {
        this.$nextTick(()=>{
            this.$refs.chart.clear();
            this.setoption();
            window.addEventListener("resize", this.resizeTheChart);
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeTheChart);
    },
    methods:{
        resizeTheChart() {
            if (this.$refs.chart) {
                this.$refs.chart.resize();
            }
        },
        setoption(){
            this.$refs.chart.setOption(this.option, true);
        }
    },
    props:{
       chartSeries:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
    },
    data(){
        return {
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    bottom: 'bottom',
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    bottom: '30%',
                    top: '0%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    axisLabel:{
                        show: false
                    }
                },
                yAxis: {
                    type: 'category',
                    axisLine:{
                        show:false
                    },
                    data: ['below 50', '50-60', '60-70', 'over 70']
                },
                series: this.chartSeries
                // [
                //     {
                //         name: 'number of member',
                //         type: 'bar',
                //         data: this.chartSeries[0].data,
                //         itemStyle: {
                //             // borderRadius: 8,
                //             opacity:0.8, 
                //             color:function(params) {
                //                 let colorList = [           
                //                     '#03045e','#0077b6','#00b4d8','#90e0ef',                                    
                //                 ];
                //                 return colorList[params.dataIndex]
                //             }
                            
                //         },
                //     },
                // ]
            }
        }
    }
}
</script>